import { defineComponent, h } from 'vue';
import { QInput, QIcon } from 'quasar';
import BaseComponent from './BaseComponentMixin.jsx';

import utils from '../../Shared/utils.jsx';
import methods from '../../Shared/methods';

export default defineComponent({
    name: 'search',
    mixins: [BaseComponent],
    components: { QInput, QIcon },
    data: function () {
        return {
            Input: {
                SearchText: ''
            },
            debounceDelayEval: null,
            fontSizeEval: null,
            colorEval: null,
            cssClassEval: null,
            placeholderEval: null,
            typingTimer: null,
            isDisabledEval: null,
        }
    },
    computed: {
        debounceDelay(){
            if(this.debounceDelayEval === null && this.controlData.DebounceDelay)
                this.debounceDelayEval = utils.compile(this, this.controlData.DebounceDelay);
            if(this.debounceDelayEval)
                return utils.evaluate(this.debounceDelayEval, this);
            return '';
        },
        fontSize() {
            if(this.fontSizeEval === null && this.controlData.FontSize)
                this.fontSizeEval = utils.compile(this, this.controlData.FontSize);
            if(this.fontSizeEval)
                return utils.resolveFontSize(utils.evaluate(this.fontSizeEval, this));
            return '';
        },
        color() {
            if(this.colorEval === null && this.controlData.Color)
                this.colorEval = utils.compile(this, this.controlData.Color);
            if(this.colorEval)
                return utils.evaluate(this.colorEval, this);
            return '';
        },
        cssClass() {
            if(this.cssClassEval === null && this.controlData.CssClass)
                this.cssClassEval = utils.compile(this, this.controlData.CssClass);
            if(this.cssClassEval)
                return utils.evaluate(this.cssClassEval, this);
            return '';
        },
        placeholder() {
            if (this.placeholderEval === null && this.controlData.Placeholder)
                this.placeholderEval = utils.compile(this, this.controlData.Placeholder);
            if (this.placeholderEval)
                return utils.evaluate(this.placeholderEval, this);
            return '';
        },
        showclear() {
            return !!this.controlData.ShowClearButton;
        },
        isDisabled() {
            try {
                if (this.isDisabledEval === null && this.controlData.IsDisabled)
                    this.isDisabledEval = utils.compile(this, this.controlData.IsDisabled);
                if (this.isDisabledEval)
                    return utils.evaluate(this.isDisabledEval, this);
                return false;
            }
            catch (e) {
                utils.warn('IsDisabled could not evaluate expression: ' + this.controlData.IsDisabled + '; ' + e);
                return false;
            }
        },
        inputStyles() {
            const hints = utils.resolveStyleHints(this.styleHints, this);
            return {
                ...hints,
                ...(this.fontSize ? { fontSize: this.fontSize } : {}),
                ...(!hints.color && this.color ? { color: this.color } : {}),
            };
        },
    },
    //Mounted Replaced with preRenderComplete
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        search(value) {
            if (this.typingTimer != null)
                clearTimeout(this.typingTimer); // clear any original timer that may still be active.

            this.Input.SearchText = value;

            // this will wait for .5 second for any additional typing (or additional async lookups to finish) so we don't fire the filter too quickly
            this.typingTimer = setTimeout(() =>
            {
                utils.executeAndCompileAllActions(this.controlData.SearchAction || this.controlData.SearchActions, this.Input, this);
            }, this.controlData.DebounceDelay || 500);
        }
    },
    props: {
    },
    render() {
        if(!this.todisplay)
            return null;
        
        try {
            return (
                <div
                    v-show={this.isvisible}
                    class={{ 'c-Search': true, [`c-name-${this.name || 'unnamed'}`]: true, 'q-ma-sm': true }}
                    style={this.sizeStyle}>
                    <QInput
                        id={`search-v-${this._uid}`}
                        modelValue={this.Input.SearchText}
                        placeholder={this.placeholder}
                        style={this.inputStyles}
                        hide-bottom-space
                        dense
                        outlined
                        disable={this.isDisabled}
                        clearable={this.showclear}
                        label={this.Translate(this.controlData.Title)}
                        autocomplete="off"
                        onUpdate:modelValue={(e) => this.search(e)}
                        vSlots={{ prepend: () => <QIcon name="mdi-magnify" /> }}
                    />
                </div>
            );
        }
        catch (e) {
            utils.error('Search Render failed', e);
            return <div>Search Failed to Render {e}</div>;
        }
    }
});